import { useState, useMemo, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TemplateOptions, ResourceFields } from 'modals/CreateTemplate';
import InfoBox from 'components/info-box';
import HelpTooltip from 'components/help-tooltip';

import './RecurAdvanced.styles.css';

const RecurAdvanced = ({ options, fieldsOffset, resourceType, onOptionsChange, onFieldsChange }) => {
    const { t } = useTranslation(['template', 'date'])

    const defaultFields = useMemo(() => {
        if (resourceType === 'task') {
            return [
                { type: 'due_date', value: null },
                { type: 'start_date', value: null }
            ];
        }

        return [
            { type: 'end', value: null },
            { type: 'start', value: null }
        ];
    }, [resourceType]);

    const [fieldsOffsetState, setFieldsOffsetState] = useState(fieldsOffset?.length ? fieldsOffset : defaultFields);

    const handleOffsetChange = useCallback((offset, type) => {
        setFieldsOffsetState(prevState => [...prevState].map(field => {
            if (field.type !== type) {
                return field;
            }

            return {
                ...field,
                offset
            };
        }))
    }, []);

    const computedFieldsOffset = useMemo(() => {
        return fieldsOffsetState.filter(field => options.includes(field.type));
    }, [fieldsOffsetState, options]);

    useEffect(() => {
        onFieldsChange?.(fieldsOffsetState);
    }, [fieldsOffsetState]);

    return (
        <div className="recur-advanced">
            <TemplateOptions value={options} type={resourceType} onChange={onOptionsChange} />

            <div className="recur-advanced-fields">
                <div className="fields-head">
                    <div className="fields-row">
                        <div className="fields-cell cell-xxs" />

                        <div className="fields-cell cell-xs" />

                        <div className="fields-cell align-left">
                        </div>

                        <div className="fields-cell cell-s">
                            { t('template:offset.start') }

                            <span className="tag-pill tag-pill-alt">{ t('date:days') }</span>

                            <HelpTooltip theme="light">
                                { resourceType === 'task' ? t('create.childrenHelp.tasks') : t('create.childrenHelp.milestonesAndTasks') }
                            </HelpTooltip>
                        </div>

                        <div className="fields-cell cell-s">
                            { t('template:offset.end') }

                            <span className="tag-pill tag-pill-alt">{ t('date:days') }</span>

                            <HelpTooltip theme="light">
                                { resourceType === 'task' ? t('create.childrenHelp.tasks') : t('create.childrenHelp.milestonesAndTasks') }
                            </HelpTooltip>
                        </div>
                    </div>
                </div>

                <ResourceFields
                    type={resourceType}
                    fields={computedFieldsOffset}
                    onChange={handleOffsetChange}
                />
            </div>
        </div>
    );
}

export default RecurAdvanced;
